import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './sidebar-component/sidebar-component.component';
import { HeaderComponent } from './header/header.component';
import { CardComponentComponent } from './card-component/card-component.component';
import { ElementModule } from './elements/element.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './interceptor/tokenInterceptor';
import { BenchmarkingComponent } from './benchmarking/benchmarking.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { AddcardComponent } from "../app/popups/addcard/addcard.component";
import { AddgraphComponent } from "../app/popups/addgraph/addgraph.component";
import { EditCardComponent } from "./popups/editCard/editCard.component";
import { EditwidgetComponent } from "../app/popups/editwidget/editwidget.component";
import { ViewallcardComponent } from "../app/popups/viewallcard/viewallcard.component";
import { NgxUiLoaderService, NgxUiLoaderModule } from "ngx-ui-loader";
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgDatepickerModule } from 'ng2-datepicker';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ErrorpopupComponent } from './popups/errorpopup/errorpopup.component';
import { SnackbarComponent } from './popups/snackbar/snackbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DateformatterPipe } from './pipe/dateformatter.pipe';
import { GraphsModule } from './modules/graphs/graphs.module';
import { MainComponent } from './main/main.component';
import { AlertModule } from './modules/alert/alert.module';
import { UserModule } from './modules/user/user.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ExternalAnalysisComponent } from './modules/external-analysis/external-analysis.component';
import { SafePipe } from './pipe/safe.pipe';
import { ThemeService } from 'ng2-charts';


@NgModule({
  declarations: [
    AppComponent, SidebarComponent, HeaderComponent, CardComponentComponent, BenchmarkingComponent, MonitoringComponent, AddcardComponent, AddgraphComponent,EditCardComponent,
    EditwidgetComponent, ViewallcardComponent, ErrorpopupComponent, SnackbarComponent, DateformatterPipe, MainComponent, ResetPasswordComponent, ExternalAnalysisComponent, SafePipe,
  ],
  imports: [
    BrowserModule, HttpClientModule, GraphsModule,AlertModule,UserModule,
    AppRoutingModule, ElementModule, NgxUiLoaderModule, NgScrollbarModule, NgDatepickerModule, MyDateRangePickerModule, FormsModule, ReactiveFormsModule,
    DragDropModule, BrowserAnimationsModule, NgMultiSelectDropDownModule.forRoot()],
  providers: [
    NgxUiLoaderService, {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },ThemeService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }